window.openTabFromHash = function(tabs, hash) {
    var found = tabs.find(v => v == hash);
    if (found) {
        openTab(found);
    }
}

window.openTab =  function(name) {
    if (!name) return;
    var selector = `[data-toggle="tab"][href="${name}"]`;
    $(selector).tab('show')
    location.href = name;
}
